module.exports = __webpack_public_path__ + "img/flow-step-2.1eea649.png";